/**
 * Which treatment the forced active-cycle fixture may add to Home's Today list.
 *
 * The fixture used to add a Gonal-F stimulation dose and an ultrasound
 * monitoring visit to every forced cycle, whatever its type or step. Evidence
 * built on it showed a sperm-freezing patient a stimulation injection, and a
 * patient with a positive result an 8:30 monitoring scan (#3667). Each row is
 * now added only where it is clinically true: in the stimulation step of a
 * cycle type that has it, before any result is recorded.
 *
 * Kept free of the fixture module's URL reads so the rule can be asked in a
 * test.
 */

/** Cycle types stimulated with an IVF-level gonadotropin dose. */
const GONADOTROPIN_CYCLE_TYPES = new Set([
  "ivf",
  "icsi",
  "egg_freezing",
  "embryo_freezing",
]);

/**
 * Cycle types with monitoring scans: the stimulated ones, IUI and ovulation
 * induction follow the follicles too, and a frozen transfer checks the lining.
 */
const MONITORED_CYCLE_TYPES = new Set([
  ...GONADOTROPIN_CYCLE_TYPES,
  "iui",
  "oi",
  "fet",
]);

/** The step the hub records stimulation (or lining preparation) on. */
const STIMULATION_PHASES = new Set(["protocol", "stimulation"]);

export function devTodayTreatment(params: {
  cycleType: string | null | undefined;
  currentPhase: string | null | undefined;
  hasOutcome: boolean;
}): { stimulationDose: boolean; monitoringVisit: boolean } {
  const { cycleType, currentPhase, hasOutcome } = params;
  const inStimulation =
    !hasOutcome && !!currentPhase && STIMULATION_PHASES.has(currentPhase);
  return {
    stimulationDose:
      inStimulation && !!cycleType && GONADOTROPIN_CYCLE_TYPES.has(cycleType),
    monitoringVisit:
      inStimulation && !!cycleType && MONITORED_CYCLE_TYPES.has(cycleType),
  };
}
